var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"legal-disclaimer"}},[_c('div',{staticClass:"inner-content"},[_c('p',{staticClass:"legal-copy"},[_vm._v("For US health care professionals")])])])
}]

export { render, staticRenderFns }